export const projectMutationFrag = `
    id
`;
